import { render, staticRenderFns } from "./CounselorCallBack.vue?vue&type=template&id=935a907e"
import script from "./CounselorCallBack.vue?vue&type=script&lang=js"
export * from "./CounselorCallBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports